import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { createEntries } from "../../../../../../../actions/entry";
import { GroupEventDivisionSelector } from "../../../../../../layout/eventDivision/GroupEventDivisionSelector";
import { AutoProgressButton } from "../../../../../../layout/forms/fields/AutoProgressButton";
import { T } from "../../../../../../util/t";

export const AddEntryButton = ({
    athlete,
    tagId,
    setDisappearingEvent,
    eventDivisions,
    addToDivision,
    setAddToDivision,
}) => {
    const { event_division_id } = useParams();

    const dispatch = useDispatch();
    const addEntry = useCallback((eventDivisionId) => {
        return dispatch(
            createEntries(
                eventDivisionId,
                [
                    {
                        athlete_id: athlete.id,
                        nfc_tag_id: tagId,
                        status: "confirmed",
                    },
                ],
                false,
            ),
        ).then(() => {
            setDisappearingEvent({ type: "success" });
            setAddToDivision(false);
        });
    }, []);

    const onAddAnyway = useCallback(
        () =>
            eventDivisions.size > 0
                ? setAddToDivision(true)
                : addEntry(event_division_id),
        [addEntry, event_division_id, eventDivisions.size],
    );

    if (addToDivision)
        return (
            <GroupEventDivisionSelector
                onSubmit={addEntry}
                eventDivisions={eventDivisions}
            />
        );
    return (
        <AutoProgressButton variant="contained" onClick={onAddAnyway}>
            <T>Add anyway</T>
        </AutoProgressButton>
    );
};
